export const BF_TOKEN = 'bf_token';
export const BF_REFRESH = 'bf_refresh';
export const BF_SESSION_ID = 'bf_session_id';
export const TENANT_NAME = 'tenant_name';